<template>
  <div class="container">
    <div class="search" style="display:flex">
      <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline">
        <el-form-item>
          <el-select clearable @change="Search" placeholder="app 编号" v-model="search.client_app_code">
            <el-option
              v-for="item in applist"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" size="small" @click="addApns">新建</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table border v-bind:data="list">
      <!-- <el-table-column label="序号" type="index" width="50"></el-table-column> -->
      <el-table-column label="app编号">
        <template v-slot="scope">
          <span>{{ appNameCode[scope.row.client_app_code] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="推送API地址">
        <template v-slot="scope">
          <span>{{ scope.row.host }}</span>
        </template>
      </el-table-column>
      <el-table-column label="友盟MasterSecret">
        <template v-slot="scope">
          <span>{{ scope.row.app_master_secret }}</span>
        </template>
      </el-table-column>
      <el-table-column label="友盟AppKey">
        <template v-slot="scope">
          <span>{{ scope.row.app_key }}</span>
        </template>
      </el-table-column>
      <el-table-column label="推送消息title">
        <template v-slot="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Alert显示消息内容">
        <template v-slot="scope">
          <span>{{ scope.row.msg }}</span>
        </template>
      </el-table-column>
      <el-table-column label="APP应用包名">
        <template v-slot="scope">
          <span>{{ scope.row.package_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250px">
        <template v-slot="scope">
          <el-button type="primary" size="small" @click="editYoumeng(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="deleteJiguang(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      v-model:currentPage="search.page"
      :page-size="search.limit"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>

    <!-- 新增修改 -->
    <el-dialog :title="title+'友盟推送'" v-model="dialogFormVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item prop="client_app_code" label="app编号" label-width="150px">
          <el-select v-model="form.client_app_code" @change="appSelect">
            <el-option
              v-for="item in applist"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="package_name" label="APP应用包名" label-width="150px">
          <el-select v-model="form.package_name">
            <el-option
              v-for="item in packageList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="host" label="推送API地址" label-width="150px">
          <el-input v-model="form.host" type="text" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="app_master_secret" label="友盟MasterSecret" label-width="150px">
          <el-input v-model="form.app_master_secret" type="text" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="app_key" label="友盟AppKey" label-width="150px">
          <el-input v-model="form.app_key" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="title" label="推送消息title" label-width="150px">
          <el-input v-model="form.title" type="text" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="msg" label="Alert显示消息内容" label-width="150px">
          <el-input v-model="form.msg" type="text" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" v-if="!edit" @click="Validate(addconfirm)">新增</el-button>
          <el-button type="primary" v-if="edit" @click="Validate(editconfirm)">修改</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      search: {
        page: 1,
        limit: 10,
        client_app_code: ''
      },
      list: [],
      total: 0,
      dialogFormVisible: false,
      edit: false,
      form: {
        id: '',
        client_app_code: '',
        host: '',
        app_master_secret: '',
        app_key: '',
        title: '',
        msg: '',
        package_name: '',
      },
      title: '',
      rules: {
        client_app_code: [{ required: true, message: '请输入app编号', trigger: 'blur' }],
        host: [{ required: true, message: '请输入推送API地址', trigger: 'blur' }],
        app_master_secret: [{ required: true, message: '请输入友盟MasterSecret', trigger: 'blur' }],
        app_key: [{ required: true, message: '请输入友盟AppKey', trigger: 'blur' }],
        title: [{ required: true, message: '请输入推送消息title', trigger: 'blur' }],
        msg: [{ required: true, message: '请输入推送消息Alert显示消息内容', trigger: 'blur' }],
        package_name: [{ required: true, message: '请输入APP应用包名', trigger: 'blur' }],
      },
      applist: [],
      appNameCode: {},
      packageList: []
    }
  },
  computed: {},
  watch: {},
  methods: {
    appSelect () {
      this.packageList = []
      this.applist.forEach(item => {
        if (item.code == this.form.client_app_code) {
          this.form.package_name = item.ios_package
          this.packageList.push({name: 'IOS',value:item.ios_package},{name: 'Android',value:item.android_package})
        }
      })
    },
    handleCurrentChange(val) {
      this.search.page = val
      this.Search()
    },
    GetappCode() {
        this.api.ClientList({
            page: 1,
            limit: 100
        }).then(res => {
        if (res.data.code == 200) {
          this.applist = res.data.data.data
          res.data.data.data.forEach(item => {
            this.appNameCode[item.code] = item.name
          })
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    Search() {
      this.api.UpushList(this.search).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.data
          this.total = res.data.data.page_info.total
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    deleteJiguang(item) {
      this.$confirm('是否删除该友盟推送?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除请求
        this.api.UpushDelete({id: item}).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.Search()
            return
          }
          this.$message.error('删除失败' + res.data.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        });
      })
    },
    addApns () {
        // 清空表单验证
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.form = {}
      this.edit = false
      this.title = '新增'
      this.dialogFormVisible = true
    },
    editYoumeng (item) {
      this.form = {}
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.edit = true
      this.title = '编辑'
      this.dialogFormVisible = true
      this.api.UpushDetail({id:item.id}).then(res => {
        if (res.data.code == 200) {
          this.form=res.data.data
          this.appSelect()
          return
        }
        this.$message.error('获取详情失败' + res.data.msg)
      })
    },
    Validate: function (call) {
      this.$refs['form'].validate(res => {
        if (res && call) {
          call()
        }
      })
    },
    update () {
      this.api.UpushUpdate(this.form).then(res => {
        if (res.data.code == 200) {
          this.$message.success(this.title +'成功')
          this.dialogFormVisible = false
          this.Search()
          return
        }
        this.$message.error(this.title +'失败' + res.data.msg)
      })
    },
    addconfirm (){
        this.update()
    },
    editconfirm (){
        this.update()
    },
  },
  filters: {},
  mounted () {
    this.Search()
    
  },
  created () {
    this.GetappCode()
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
</style>
